import { Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import { useState } from 'react';

export default function CopyToClipboard({ contentToCopy, children }) {
    const [isClicked, setIsClicked] = useState(false);
    const [bgColor, setBgColor] = useState('lightblue');

    const handleCopySuccess = (isSuccess=true) => {
        setBgColor(isSuccess ? 'var(--alert-success)' : 'var(--alert-error)');
        setTimeout(() => {
            setBgColor('');        
        }, 2000);
    };

    const copy = () => {
        setTimeout( async () => {
            setIsClicked(true);
            await navigator.clipboard.writeText(contentToCopy)
            .then(() => {
                handleCopySuccess(true);
            })
            .catch( (error) => {
                handleCopySuccess(false);
            });
        }, 100);
        setTimeout( async () => {
            setIsClicked(false);
        }, 2000);
    }
     
    return (
        <Tooltip title="Click to copy" placement='bottom' slotProps={{
            popper: {
            modifiers: [
                {
                name: 'offset',
                options: {
                    offset: [0, -10],
                },
                },
            ],
            },
        }}>
            <Box onClick={copy}
                sx={{
                    background: 'linear-gradient(to left, transparent 50%, grey 50%) right',
                    backgroundSize: '250%',
                    ...(isClicked ? { backgroundColor: bgColor, } : {}),
                    transition: '.5s ease-out',
                    cursor: 'pointer',
                    '&:hover' : isClicked ? {} : {
                        backgroundPosition: 'left',
                        color: 'white',
                    }
                }}
            >
            { children }
            </Box>
        </Tooltip>
    )
}